export const environment = {
  production: false,
  serverUrl: 'https://q2is1jp2f7.execute-api.us-east-2.amazonaws.com/dev',
  bucket: 'biodatav2qpcr-prod-upload',
  userPool: {
    UserPoolId: 'us-east-2_fcpit7xMW',
    ClientId: 'bdv3vn3qk9794teda2h8o0kl1',
    region: 'us-east-2'
  },
  identityPoolId: 'us-east-2:c02362f1-cc68-4012-b4d4-48fbd446d306',
  buckets: {
    'us-east-2': 'biodatav2qpcr-prod-upload'
  },
  modules: {
    key: 'analysisType',
    values: [
        {
          'name': 'qPCR',
          'desc': 'qPCR'
        }
    ]
},
  version: 'version 2.0',
  defaultRegion: 'us-east-2',
  cognito: {
    identityPoolId: 'us-east-2:c02362f1-cc68-4012-b4d4-48fbd446d306', // REQUIRED - Amazon Cognito Identity Pool ID
    region: 'us-east-2', // REQUIRED - Amazon Cognito Region
    userPoolId: 'us-east-2_fcpit7xMW', // OPTIONAL - Amazon Cognito User Pool ID
    userPoolWebClientId: 'bdv3vn3qk9794teda2h8o0kl1', // OPTIONAL - Amazon Cognito Web Client ID
  },
  Storage: {
    AWSS3: {
      bucket: 'biodatav2qpcr-prod-upload', // REQUIRED -  Amazon S3 bucket
      region: 'us-east-2', // OPTIONAL -  Amazon service region
    }
  }
};
const awsconfig = {
  'aws_project_region': 'us-east-2',
  'aws_cognito_region': 'us-east-2',
  'aws_user_pools_id': 'us-east-2_fcpit7xMW',
  'aws_user_pools_web_client_id': 'bdv3vn3qk9794teda2h8o0kl1',
  'aws_cognito_mfa_configuration': 'OPTIONAL',

};
export default awsconfig;
